import styled from 'styled-components'

export const ProfileInfoTitle = styled.p`
  font-weight: 700;
  margin-bottom: 2.25rem;
`
